/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Structured_OutputInputs */

const en_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured output`)
};

const ar_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخرجات منظمة`)
};

const bn_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্রাকচার্ড আউটপুট`)
};

const de_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturierte Ausgabe`)
};

const es_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida estructurada`)
};

const fr_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortie structurée`)
};

const pt_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída estruturada`)
};

const zh_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结构化输出`)
};

const tr_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapılandırılmış çıktı`)
};

const ru_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Структурированный вывод`)
};

const pl_svchip_structured_output = /** @type {(inputs: Svchip_Structured_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane wyjściowe strukturyzowane`)
};

/**
* | output |
* | --- |
* | "Structured output" |
*
* @param {Svchip_Structured_OutputInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_structured_output = /** @type {((inputs?: Svchip_Structured_OutputInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Structured_OutputInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_structured_output(inputs)
	if (locale === "bn") return bn_svchip_structured_output(inputs)
	if (locale === "de") return de_svchip_structured_output(inputs)
	if (locale === "es") return es_svchip_structured_output(inputs)
	if (locale === "fr") return fr_svchip_structured_output(inputs)
	if (locale === "pt") return pt_svchip_structured_output(inputs)
	if (locale === "zh") return zh_svchip_structured_output(inputs)
	if (locale === "tr") return tr_svchip_structured_output(inputs)
	if (locale === "ru") return ru_svchip_structured_output(inputs)
	if (locale === "pl") return pl_svchip_structured_output(inputs)
	return en_svchip_structured_output(inputs)
});